/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_OfInputs */

const fr_activity_of = /** @type {(inputs: Activity_OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`activité de `)
};

const en_activity_of = /** @type {(inputs: Activity_OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`activity for `)
};

/**
* | output |
* | --- |
* | "activity for" |
*
* @param {Activity_OfInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const activity_of = /** @type {((inputs?: Activity_OfInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_OfInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_activity_of(inputs)
	return en_activity_of(inputs)
});